export function useIsMobile(breakpoint = 768) {
  const isMobile = ref(false)

  if (import.meta.client) {
    isMobile.value = window.innerWidth <= breakpoint
    const onResize = () => {
      isMobile.value = window.innerWidth <= breakpoint
    }
    window.addEventListener('resize', onResize)
    onUnmounted(() => window.removeEventListener('resize', onResize))
  }

  return isMobile
}
